/* eslint-disable */

import React from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";

import WrapperDoubleClickable from "../wrapper-double-clickable/wrapper-double-clickable.tsx";
import RaindropButton, {
  ButtonStyle,
} from "../raindrop-button/raindrop-button.tsx";

import RaindropTitle from "../raindrop-title/raindrop-title.tsx";
import VersionDisplay from "..//version-display/version-display";
import { Size } from "../../logic/enums.ts";
import RaindropCard from "../raindrop-card/raindrop-card.tsx";
import RaindropClickable from "../raindrop-clickable/raindrop-clickable.tsx";
import RaindropCopyrightDeclaration from "../raindrop-copyright-declaration/raindrop-copyright-declaration.js";
import { isProductionEnvironment } from "../../services/environment.js";

const SideBarTabIndicator = () => {
  return (
    <div id="indicator" className={"absolute flex h-2 w-2 translate-x-2 "}>
      <div
        className={
          "animate-ping absolute inline-flex h-full w-full rounded-full bg-color-raindrop-primary opacity-75"
        }
      />
      <div
        className={
          "relative inline-flex rounded-full h-2 w-2 bg-color-raindrop-primary opacity-80"
        }
      />
    </div>
  );
};

const SideBarTabOption = ({
  icon = "fa-search",
  text = "Search",
  to = "/",
  onClick = () => {},
  onDoubleClick = () => {},
  isSelected = false,
  showIndicator = false,
}) => {
  let iconColor = "text-color-dark-text-secondary";
  let textColor =
    "dark:text-color-dark-text-secondary text-color-dark-text-secondary";
  let opacityClass = "opacity-100";
  let rotateClass = "rotate-0";
  let bgClass = "";
  let borderClass = "border-transparent";
  let hoverClass =
    "hover:bg-color-background-secondary dark:hover:bg-color-dark-background-secondary";

  switch (text) {
    case "Home":
      iconColor = "text-blue-500";
      break;
    case "Contribution":
      iconColor = "text-purple-500";
      break;
    case "Search":
      iconColor = "text-cyan-600";
      break;
    case "Profile":
      iconColor = "text-green-500";
      break;
    case "Waterfall":
      iconColor = "text-blue-500";
      break;
    case "Notifications":
      iconColor = "text-yellow-500";
      break;
    case "Settings":
      iconColor = "text-gray-500";
      break;

    case "Volunteer":
      iconColor = "text-teal-500";
      break;

    default:
      iconColor = "text-gray-500";
      break;
  }

  if (isSelected) {
    opacityClass = "opacity-100";
    // textColor = "text-color-raindrop-primary";
    // iconColor = "text-color-raindrop-primary";
    // bgClass = "bg-color-raindrop-primary bg-opacity-5";
    bgClass = "bg-blue-500 bg-opacity-5";
    // borderClass = "border-color-raindrop-primary border-opacity-20";
    borderClass = "border-blue-500 border-opacity-20";
    hoverClass = "";
  }

  return (
    <WrapperDoubleClickable onDoubleClick={onDoubleClick}>
      <Link
        to={to}
        className={`flex  flex-col  justify-center gap-1 items-start gap-1/2 relative transition-all pt-2  `}
        onClick={onClick}
      >
        <div
          className={`flex flex-row items-center  gap-4 transition-all ${textColor}  ${opacityClass} ${rotateClass} ${bgClass} ${borderClass} border-2 rounded-xl p-2 px-4 w-full ${hoverClass}`}
        >
          <div className="flex flex-col items-center">
            <i
              className={`fa ${icon} text-3xl font-black ${iconColor} w-8 text-center `}
            />
            {showIndicator && <SideBarTabIndicator />}
          </div>

          <div className={` text font-black transition-all uppercase`}>
            {text}
          </div>
        </div>
      </Link>
    </WrapperDoubleClickable>
  );
};

const RaindropPlusOption = ({
  isRaindropPlus = false,
  isAnonymous = false,
}) => {
  const navigate = useNavigate();

  if (isAnonymous) {
    return null;
  }

  if (isRaindropPlus) {
    return null;
  }

  return (
    <div className="flex w-full px-4 font-black">
      <RaindropClickable
        onClick={() => {
          navigate("/raindrop/upgrade");
        }}
        additionalClasses="w-full"
      >
        <RaindropCard>
          <div className="flex flex-col gap-2 ">
            <i className="fa-solid fa-gem text-color-raindrop-primary text-3xl" />
            <div className="flex flex-col ">
              <h1 className="font-black text-color-text-primary dark:text-color-dark-text-primary text-lg">
                Raindrop Plus
              </h1>
              <h2 className="font-bold text-color-text-secondary">
                Upgrade for free
              </h2>
            </div>
          </div>
        </RaindropCard>
      </RaindropClickable>
    </div>
  );
};

const ThemeToggleSection = () => {
  return (
    <div className="flex w-full items-center justify-center">
      <RaindropButton icon="fa-moon" title="Dark mode" />
    </div>
  );
};

const RaindropSideBar = ({
  userCurrent,
  onResetCircle = () => {},
  showIndicatorOnSearch = false,
  isRaindropPlus = false,
}) => {
  const pathname = useLocation().pathname;
  const navigate = useNavigate();

  const urlProfile = `/raindrop/account/${userCurrent?.account.id}`;

  const isAnonymous = userCurrent === null;

  let flexDirection = "flex-col";
  let bottomPadding = "pb-0";
  let gap = "gap-4";
  let widthClass = "w-fit";
  let heightClass = "h-full";

  let waterfallUrl = "/raindrop/waterfall-create";
  if (userCurrent?.account?.primaryWaterfall) {
    waterfallUrl = `/raindrop/waterfall/${userCurrent.account.primaryWaterfall.id}`;
  }

  return (
    <div
      className={`flex ${flexDirection} ${widthClass} ${gap} ${bottomPadding} ${heightClass}  pointer-events-auto pt-3 border-r-2 dark:border-color-dark-border-primary border-color-border-primary relative overflow-y-scroll no-scrollbar`}
    >
      <div className="flex flex-col items-center gap-2 h-full w-full text-left pt-4 ">
        <RaindropTitle size={Size.Medium} style={ButtonStyle.Primary} />
        <h4 className="font-black text-xs text-color-dark-text-tertiary opacity-50">
          <VersionDisplay />
        </h4>
      </div>

      <RaindropPlusOption
        isRaindropPlus={isRaindropPlus}
        isAnonymous={isAnonymous}
      />

      <div className="flex flex-col px-2 w-full">
        {isAnonymous && (
          <div className="flex flex-col gap-2 pt-8 px-2 pb-6">
            <RaindropButton
              title={"Sign up"}
              to={"/raindrop/sign-up"}
              size={Size.Large}
              style={ButtonStyle.Primary}
              isFluid={true}
            />
            <RaindropButton
              title={"Login"}
              to={"/raindrop/login"}
              size={Size.Large}
              isFluid={true}
            />
          </div>
        )}
        <SideBarTabOption
          to={"/raindrop/activity"}
          icon={"fa-home"}
          text={"Home"}
          isSelected={pathname === "/raindrop/activity"}
          onDoubleClick={() => {
            navigate("/raindrop/tour");
          }}
        />

        <SideBarTabOption
          to={"/raindrop/contribution"}
          icon={"fa-chart-pie"}
          text={"Contribution"}
          // onClick={onResetCircle}
          onDoubleClick={() => {
            navigate("/raindrop/meditate");
          }}
          isSelected={pathname === "/raindrop/contribution"}
        />
        <SideBarTabOption
          to={"/raindrop/search"}
          icon={"fa-search"}
          showIndicator={showIndicatorOnSearch}
          text={"Search"}
          onDoubleClick={() => {
            navigate("/raindrop/pomodoro");
          }}
          isSelected={pathname === "/raindrop/search"}
        />
        {!isAnonymous && (
          <SideBarTabOption
            to={urlProfile}
            icon={"fa-user"}
            showIndicator={showIndicatorOnSearch}
            text={"Profile"}
            isSelected={pathname === urlProfile}
          />
        )}
        <SideBarTabOption
          to={waterfallUrl}
          icon={"fa-droplet"}
          showIndicator={showIndicatorOnSearch}
          text={"Waterfall"}
          isSelected={pathname.startsWith("/raindrop/waterfall")}
          onDoubleClick={() => {
            navigate("/raindrop/bombshell");
          }}
        />
        {!isProductionEnvironment() && (
          <SideBarTabOption
            to={"/raindrop/volunteer"}
            icon={"fa-seedling"}
            text={"Volunteer"}
            isSelected={pathname === "/raindrop/volunteer"}
          />
        )}
        <SideBarTabOption
          to={"/raindrop/notifications"}
          icon={"fa-bell"}
          text={"Notifications"}
          isSelected={pathname === "/raindrop/notifications"}
        />

        <SideBarTabOption
          to={"/raindrop/settings"}
          icon={"fa-cog"}
          text={"Settings"}
          isSelected={pathname === "/raindrop/settings"}
        />
      </div>

      <div className="flex flex-col justify-end p-6 h-full">
        <p className="w-full text-center text-xs  dark:text-color-dark-text-tertiary text-color-text-tertiary opacity-50">
          Copyright © 2025 The Raindrop Group Limited. All rights reserved.
        </p>
      </div>
    </div>
  );
};

export default RaindropSideBar;
